import Link from "next/link";
import { ReactNode } from "react";

type Props = {
  id?: string;
  href: string;
  children: ReactNode | string;
  nextLink?: boolean;
  newTab?: boolean;
  className?: string;
  onClick?: (e: any) => void;
  as?: string;
};

/**
 * Note: When `onClick` is provided, `href` will NOT run if `false | undefined` is returned from the `onClick` function.
 */
export const PrimeLink = ({
  id,
  href,
  children,
  nextLink,
  newTab,
  className = "",
  onClick,
  as,
}: Props) => {
  const combinedClassname = `text-brand-primary underline cursor-pointer ${className}`;

  if (nextLink) {
    return (
      <Link
        href={href}
        onClick={onClick}
        className={combinedClassname}
        target={newTab ? "_blank" : "_self"}
        rel={newTab ? "noopener noreferrer" : ""}
        id={id}
        as={as}
      >
        {children}
      </Link>
    );
  }

  return (
    <a id={id} href={href} className={combinedClassname} onClick={onClick}>
      {children}
    </a>
  );
};
